import { Box, BoxProps, Text, TextProps } from '@jfs/ui-new'

interface FormTitleInterface {
  title: string
}

export const FormTitle = ({ title }: FormTitleInterface) => {
  return (
    <Box {...styles.titleContainer}>
      <Text {...styles.customerValidationTitle} title={title} />
    </Box>
  )
}

export const styles = {
  titleContainer: {
    justify: 'center',
    align: 'center',
  } as BoxProps,

  customerValidationTitle: {
    fontSize: 16,
    fontFamily: 'jiotype-medium',
    color: 'PRIMARY_STORNG',
  } as TextProps,
}
